// @flow

import Browsers from '../constants/Browsers';

export default class Template {
  /**
   *
   */
  static getContent(template: any): HTMLElement {
    const html: HTMLElement | null = document.documentElement;
    if (html) {
      let base: any = null;
      if (html.classList.contains(Browsers.INTERNET_EXPLORER)) {
        base = template;
      } else {
        base = template.content;
      }

      if (base) {
        const child: any = base.firstElementChild;
        if (child) {
          return child.cloneNode(true);
        } else {
          throw new Error('There is no content in the template');
        }
      } else {
        throw new Error('Could not get the content of the template');
      }
    } else {
      throw new Error('There is no present HTML tag');
    }
  }
}
